<template>
    <div id="app">
        <nav-bar></nav-bar> 
        <router-view></router-view>
    </div>
</template>

<script>

import navBar from '@/components/NavBar.vue'
export default {
    components: { navBar },
    data(){
        return{
            login:{
                name:'',
                password:'',
                info:'',
                messageError:''
            }
        }
    },
    beforeCreate: function () {
    if (!this.$session.exists()) {
     // this.$router.push('/')
    }
  },
  created(){
      //Se obtiene la informacion del login 
    //   if (localStorage.getItem('login-storage')) 
    //    this.login = JSON.parse(localStorage.getItem('login-storage'));
     
    //  console.log(this.login);
  },
  methods: {
    logout: function () {
      this.$session.destroy()
      this.$router.push('/')
    }
  }
}
</script>

<style>

</style>

